import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { IconElement } from '../../components/FrameMenu'
import { mergeSet } from '../../actions/project/set'

const mapStateToProps = state => ({
  isSelected: true,
  show: dotProp.get(state, `project.pictures.${state.project.selectedIndex}.setIndex`) === undefined ? false : true,
})

const mapDispatchToProps = dispatch => ({
  action: () => dispatch(mergeSet()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IconElement)



// WEBPACK FOOTER //
// ./src/containers/FrameMenu/MergeSet.js